export default {
  getAll: {
    url: '/api/paymentverify/getAll',
    method: 'get'
  },
  create: {
    url: '/api/paymentverify/create',
    method: 'post'
  },
  update: {
    url: '/api/paymentverify/update',
    method: 'put'
  },
  delete: {
    url: '/api/paymentverify/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/paymentverify.js